// removed by extract-text-webpack-plugin
module.exports = {"star-rating":"star-rating_star-rating--3leQqZeg","starRating":"star-rating_star-rating--3leQqZeg","star-rating__stars":"star-rating_star-rating__stars--12_dP_FO","starRatingStars":"star-rating_star-rating__stars--12_dP_FO","star-rating__number-value":"star-rating_star-rating__number-value--WlsO11ak","starRatingNumberValue":"star-rating_star-rating__number-value--WlsO11ak","star-styles":"star-rating_star-styles--1l2_Nq6V","starStyles":"star-rating_star-styles--1l2_Nq6V"};


//////////////////
// WEBPACK FOOTER
// ./components/profile-right-section/src/styles/star-rating.scss
// module id = 2349
// module chunks = 0